export const constants = {
  DOMAIN_OPTIONS : {
    industries: {
      dropdownValues: [
        {label: 'Accessories', value: 'Accessories'}, 
        {label: 'Health & Beauty', value: 'Health & Beauty'},
        {label: 'Home & Garden', value: 'Home & Garden'},
        {label: 'Fashion', value: 'Fashion'},
        {label: 'Technology', value: 'Technology'},
        {label: 'Travel', value: 'Travel'},
        {label: 'Other', value: 'Other'},
      ]
    }
  }
};